// 提现相关工具函数

// 提现状态常量
export const WITHDRAW_STATUS = {
  PENDING: 0,    // 待审核
  VERIFIED: 1,   // 已审核
  REJECTED: 2,   // 已驳回
  PAID: 3,       // 已支付
  FAILED: 4      // 失败
};

// 获取状态标签文本
export const getStatusLabel = (status) => {
  switch (status) {
    case WITHDRAW_STATUS.PENDING:
      return 'Pending';
    case WITHDRAW_STATUS.VERIFIED:
      return 'Verified';
    case WITHDRAW_STATUS.REJECTED:
      return 'Rejected';
    case WITHDRAW_STATUS.PAID:
      return 'Success';
    case WITHDRAW_STATUS.FAILED:
      return 'Failed';
    default:
      return 'Unknown';
  }
};

// 格式化时间
export const formatTime = (timeString) => {
  if (!timeString) return '--';
  const date = new Date(timeString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

// 格式化金额
export const formatAmount = (amount) => {
  if (!amount) return '$0.00';
  return `$${Number(amount).toFixed(2)}`;
};

// 根据筛选条件获取 dateType 参数
export const getDateTypeFromFilter = (filter) => {
  switch (filter) {
    case 'Today':
      return 'today';
    case 'This Week':
      return 'week';
    case 'This Month':
      return 'month';
    default:
      return undefined; // All 不传 dateType
  }
};

// 验证提现数据完整性
export const validateWithdrawData = (data) => {
  if (!data) return false;
  return !!(data.withdrawId && data.createTime);
};

// 生成审核历史记录
export const generateReviewHistory = (withdrawData) => {
  if (!withdrawData) return [];

  const history = [];

  // 提交记录
  history.push({
    title: 'Submit',
    time: formatTime(withdrawData.createTime),
    description: 'The request has been submitted'
  });

  // 审核记录
  if (withdrawData.status >= WITHDRAW_STATUS.VERIFIED && withdrawData.auditTime) {
    if (withdrawData.status === WITHDRAW_STATUS.VERIFIED) {
      history.push({
        title: 'Approve Request',
        time: formatTime(withdrawData.auditTime),
        description: 'The request has been approved',
        handler: 'Handled by: current_admin'
      });
    } else if (withdrawData.status === WITHDRAW_STATUS.REJECTED) {
      history.push({
        title: 'Reject Request',
        time: formatTime(withdrawData.auditTime),
        description: withdrawData.auditReason || 'The request has been rejected',
        handler: 'Handled by: current_admin'
      });
    } else if (withdrawData.status === WITHDRAW_STATUS.PAID) {
      // 先添加审核通过记录
      history.push({
        title: 'Approve Request',
        time: formatTime(withdrawData.auditTime),
        description: 'The request has been approved',
        handler: 'Handled by: current_admin'
      });
      // 再添加支付记录
      history.push({
        title: 'Marked as Paid',
        time: formatTime(withdrawData.auditTime),
        description: 'Payment has been completed'
      });
    } else if (withdrawData.status === WITHDRAW_STATUS.FAILED) {
      history.push({
        title: 'Payment Failed',
        time: formatTime(withdrawData.auditTime),
        description: 'Payment processing failed',
        handler: 'Handled by: current_admin'
      });
    }
  }

  return history;
};
